import { Outlet, createFileRoute } from '@tanstack/react-router'
import z from 'zod/v4'
import { onlineManager, useSuspenseQuery } from '@tanstack/react-query'
import {
  getBookingQueryOptions,
  getBookingTransportationQueryOptions,
} from '@/queries/query/booking'
import ModalLeaveBooking from '@/components/ui/ModalLeaveBooking'
import { queryKeys } from '@/queries/keys'

export const Route = createFileRoute(
  '/make-booking/$id/bus-details/$transportationId',
)({
  params: {
    parse: (params) => ({
      transportationId: z.string().trim().parse(params.transportationId),
    }),
    stringify: ({ transportationId }) => ({ transportationId }),
  },
  loader: ({ context, params }) => {
    if (onlineManager.isOnline() && !context.isRestoring) {
      return context.queryClient.ensureQueryData(
        getBookingTransportationQueryOptions(params.transportationId),
      )
    }
    return context.queryClient.getQueryData(
      queryKeys.booking.transportation(params.transportationId),
    )
  },
  component: RouterComponent,
})

function RouterComponent() {
  const isAuthenticated = Route.useRouteContext({
    select: (s) => s.authContext.isAuthenticated,
  })
  const bookingId = Route.useParams({
    select: (s) => s.id,
  })
  const {
    data: {
      data: { booking },
    },
  } = useSuspenseQuery(getBookingQueryOptions(bookingId))
  return (
    <>
      <Outlet />
      <ModalLeaveBooking
        isAuthenticated={isAuthenticated}
        disabledBlock={!!booking.parent}
      />
    </>
  )
}
